// Angular
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatCardModule } from "@angular/material/card";
import { MatMenuModule } from "@angular/material/menu";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

// Core Module
import { PartialsModule } from "../../partials/partials.module";
import { ProspectListComponent } from "./list/prospect-list.component";
import { ProspectDetailComponent } from "./detail/prospect-detail.component";
import { ProspectStateLabelComponent } from "./state-label/prospect-state-label.component";

@NgModule({
	imports: [
		CommonModule,
		PartialsModule,
		ReactiveFormsModule,
		NgbModule,
		DragDropModule,
		MatCardModule,
		MatMenuModule,
		RouterModule.forChild([
			{
				path: "",
				component: ProspectListComponent,
			},
			{
				path: ":id",
				component: ProspectDetailComponent,
			},
		]),
	],
	providers: [],
	declarations: [
		ProspectListComponent,
		ProspectDetailComponent,
		ProspectStateLabelComponent,
	],
})
export class ProspectsModule {}
